import React, { useMemo, useRef, useState } from "react";
import { Badge, Row, Col, Select } from "antd";
import FullCalendar from "@fullcalendar/react";
import { DateSelectArg, EventApi, EventContentArg } from "@fullcalendar/common";
import listPlugin from "@fullcalendar/list";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import multiMonthPlugin from "@fullcalendar/multimonth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChessKnight,
  faCalendarDays,
  faClock,
  faTag,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { useAuthState } from "../../context/Context";
import { getDefaultImage, imageType, ValidateIsSchool, ValidateIsTrainer } from "../../shared/Common";
import EqButton from "../eqButton/EqButton";
import AsyncImage from "../asyncImage/AsyncImage";
import { useLocation, useNavigate } from "react-router-dom";
import EqCalenderEvent from "../eqCalendar/EqCalenderEvent/EqCalenderEvent";
import { CourseUI } from "../../shared/interfaces/ridingCourse/IRidingCourse";
import "./EqDashboardCalendar.scss";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n/config";
import { Grid } from "antd-v5";
import { EqHorseTrainingType, EqTaskTypes } from "../../shared/enums";
import { IGetSchoolTrainingDto } from "../../shared/interfaces/schoolTraining/IGetSchoolTrainingDto";
import { IEqPublicEvent } from "../../shared/interfaces/GetSchoolTrainingInfoDto";
import { EqEntityHorse } from "../../shared/interfaces/horse/IHorses";
import { GetTrainingInfoDto } from "../../shared/interfaces/ITrainingInfoDtos";

const { useBreakpoint } = Grid;
export interface IDashboardCalendarProps {
  isOwner: boolean;
  events?: IEqPublicEvent[];
  trainings?: IGetSchoolTrainingDto[] | GetTrainingInfoDto[];
  courses?: CourseUI[] | null;
  horsesList?: EqEntityHorse[];
  userType?: "school" | "trainer";
}  

const EventTypes = {
  TRAINING: "training",
  EVENT: "event",
  COURSE: "course",
  HORSE_TRAINING: "horseTraining",
  HORSE_TASK: "horseTask",
  PRODUCT: "product",
};

const ColorMapping = {
  Horse: "#013220",
  Courses: "#AA336A",
  Events: "#259FAA",
  Training: "#1976D2",
};

const EqDashboardCalendar = ({
  isOwner,
  events,
  trainings,
  courses,
  horsesList,

}: IDashboardCalendarProps) => {
  const userDetails = useAuthState();
    const isSchool: boolean = ValidateIsSchool(userDetails);
    const isTrainer: boolean = ValidateIsTrainer(userDetails);
  
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const isMobile = !screens.md; // md is 768px and above, so !screens.md means less than 768px

  const calendarRef = useRef<FullCalendar | null>(null);

  const [view, setView] = useState("timeGridWeek");
  const [selectedFilter, setSelectedFilter] = useState("All");



  const [calendarData, setCalendarData] = useState() as any;
  const plugins = [dayGridPlugin, timeGridPlugin, multiMonthPlugin, listPlugin];

  

  // Handle trainer-specific actions
  const handleTrainingActionClick = (item: any) => {
    if (!Array.isArray(trainings)) return;
  
    const castedTrainings = trainings as GetTrainingInfoDto[];
  
    if (item.type === "training") {
      const selectedTraining = castedTrainings.find(
        (training) => training.key === item.key
      );
  
      if (isTrainer) {
        navigate(`/trainer/activityBoard?tab=1&&id=${selectedTraining?.id}`);
      } else if (isSchool) {
        navigate(`/school/activityBoard?tab=1&&id=${selectedTraining?.id}`);
      }
    }
  };
  



  // Handle edit event based on userType
  const handleEditEvent = (key: string) => {
    if (isTrainer) {
      navigate(`/trainer/activityBoard?tab=2&&id=${key}`);
    } else if (isSchool) {
      navigate(`/school/activityBoard?tab=2&&id=${key}`);
    }
  };


  const handleCourseActionClick = (key: string) => {
     if (isSchool) {
      navigate(`/school/trainingCourse?id=${key}`);
    }
  };
  // Event Edit


  const handleViewChange = (arg: any) => {
    const viewName = arg.view.type;
    // setCurrentView(viewName);
    setView(viewName);
  };
  // const [eventData, setEventData] = React.useState(eventList);

  const handleEventAdd = () => {
    // Do something with the new event data
    console.log("heloo");
  };
  
  // Define a custom function to render the event content
  // Helper function to get event styles
  const getEventStyles = (event:EventApi) => {
    
      const color = event.extendedProps.eventColor;

      
    return {
      style1: {
        color: color,
        border: `1px solid ${color}`,
        background: `${color}20`,
      },
      color1: { color: color },
      background: { background: color },
    };
  };

  const renderEventContent = (eventInfo: EventContentArg) => {



    const { view, event } = eventInfo;
    const { style1, color1, background } = getEventStyles(event);


   
   

    const iconType1 =
      (eventInfo.event.extendedProps.type === "training" || eventInfo.event.extendedProps.type==="horseTraining")
        ? faChessKnight
        : faCalendarDays;

    
    

    // trainning
    // Day
    if (eventInfo.event.extendedProps.type === "training") {
      if (view.type === "timeGridDay") {
        return (
          <EqCalenderEvent
          view={view}
          title={eventInfo.event.title}
          eventInfo={eventInfo}
          event={eventInfo.event.extendedProps}
          isOwner={isOwner}
          handleEditEvent={() =>
            handleTrainingActionClick(eventInfo.event.extendedProps)
          }
          handleJoinEvent={() => {}}
          onStudentJoin={() => {}}
        />
        );

      
        // Month
        // Render the event content for the month view
      } else if (view.type === "dayGridMonth") {
        if(isMobile){
          return (
            <div className="fc-event-mobile-month" style={{ backgroundColor: event.extendedProps.eventColor }}></div>
          );
        }else{
          return (
            <>
              {eventInfo.event.extendedProps.monthView && (
                <>
                  <div className="fc-event-month " style={style1}>
                    <div className="trin-info">
                      <div className="month-title">{eventInfo.event.title}</div>
                      <div className="month-type">
                        {eventInfo.event.extendedProps.type}
                      </div>
                    </div>
                    <Badge
                      style={background}
                      count={
                        eventInfo.event.extendedProps.count > 1
                          ? eventInfo.event.extendedProps.count
                          : 0
                      }
                    />
                  </div>
                  <div className="hide">{eventInfo.event.extendedProps.type}</div>
                </>
              )}
            </>
          );
        }
       
      } else {
        // week
        if(isMobile){
          return (
            <div className="fc-event-mobile-week" style={style1}>
              <span className="fc-event-title">{event.title}</span>
            </div>
          );
        }else{
          return (
            <div className="my-event timeGridWeek-event" style={style1}>
              <FontAwesomeIcon icon={iconType1} style={color1} className="icon" />
              <Col className="timeGridWeek-info training-info">
                <Row
                  className="timeGridWeek-title training-content"
                  style={color1}
                >
                  {eventInfo.event.title}
                </Row>
                <Row
                  className="timeGridWeek-time training-content"
                  style={color1}
                >
                  {moment(eventInfo.event.start).format("h:mm a")}-{" "}
                  {moment(eventInfo.event.end).format("h:mm a")}
                </Row>
              </Col>
             
            </div>
          );
        }
        }
       
      // Events
    } else if (eventInfo.event.extendedProps.type === "event") {
      if (view.type === "timeGridDay") {
        // Render the event content for the month view
        return (
          <div className="my-event timeGridDay-event" style={style1}>
            <div className="img-container">
        
              <div className="image-size">
                <AsyncImage
                  className="imge-training"
                  src={
                    eventInfo.event.extendedProps.image.url ||
                    getDefaultImage(imageType.training)
                  }
                />
              </div>
            </div>
            <div className="training-info">
            <Row  className="training-row">
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    <Col className="icon">
                      <FontAwesomeIcon
                        icon={iconType1}
                        style={color1}
                        
                      /></Col>
                    <Col className="training-content">

                        <span className="heading" style={color1}>
                          {t("event")}:
                        </span>{" "}
                        <span className="info" style={color1}>
                          {eventInfo.event.title}
                        </span>

                    </Col>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    <Col>
                      <FontAwesomeIcon
                        icon={faLocationDot}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          {t("area")}:
                        </span>{" "}
                        <span className="info" style={color1}>
                          {eventInfo.event.extendedProps.location?.city}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    <Col>
                      <FontAwesomeIcon
                        icon={faClock}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          {t("time")}:
                        </span>{" "}
                        <span className="info info-time" style={color1}>
                          {t("at")} {moment(eventInfo.event.start).format("h:mm a")}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  {eventInfo.event.extendedProps.price && (
                  <Row className="content-row">
                    <Col>
                      <FontAwesomeIcon
                        icon={faTag}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          {t("price")}:
                        </span>{" "}
                        <span className="info" style={color1}>
                          Kr.{" "}
                          {`${eventInfo.event.extendedProps.price.toFixed(2)}`}
                        </span>
                      </div>
                    </Col>
                  </Row>
                    )}
                </Col>
              </Row>
        
            </div>
            <div className="book-btn">
              {/* {isTrainer || isSchool ? ( */}
              {isOwner ? (
                <>
               <EqButton
                  className="btn bordered"
                  onClick={() =>
                    handleEditEvent(eventInfo.event.id)
                  }
                >
                  {t("edit")}
                </EqButton>
                </>
              ) : (
                <EqButton
                  onClick={() =>{

                    // handleJoinEvent(eventInfo.event.extendedProps.key)
                    navigate(`/publicEventSingle?id=${eventInfo.event.id}`);
                  }
                  }
                >
                  {t("view")}
                </EqButton>
              )}
            </div>
          </div>
        );
        // month
      } else if (view.type === "dayGridMonth") {
        if(isMobile){
          return (
            <div className="fc-event-mobile-month" style={{ backgroundColor: event.extendedProps.eventColor }}></div>
          );
        }else{

          return (
            <>
            <div
              className="fc-event-month events-month"
              style={{
                color: `${eventInfo.event.extendedProps?.eventColor}`,
                border: `1px solid ${eventInfo.event.extendedProps?.eventColor}`,
                background: `${eventInfo.event.extendedProps.eventColor}20`,
              }}
            >
              <div className="month-title">{eventInfo.event.title}</div>
              <div>{eventInfo.event.extendedProps.type}</div>
            </div>
            <div className="hide">{eventInfo.event.extendedProps.type}</div>
          </>
        );
      }
      } else {
        // week
        if(isMobile){
          return (
            <div className="fc-event-mobile-week" style={style1}>
              <span className="fc-event-title">{event.title}</span>
            </div>
          );
        }else{
        return (
          <div className="my-event timeGridWeek-event" style={style1}>
            <FontAwesomeIcon icon={iconType1} style={color1} className="icon" />
     
            <Col className="timeGridWeek-info training-info">
              <Row
                className="timeGridWeek-title training-content"
                style={color1}
              >
                {eventInfo.event.title}
              </Row>
              <Row
                className="timeGridWeek-time training-content"
                style={color1}
              >
                {moment(eventInfo.event.start).format("h:mm a")}
              </Row>
            </Col>
          </div>
        );
      }
      }
      // Course
    } else if (eventInfo.event.extendedProps.type === "course") {
      if (view.type === "timeGridDay") {
        // Render the event content for the month view
        return (
          <div className="my-event timeGridDay-event" style={style1}>
            <div className="img-container">
        
              <div className="image-size">
                <AsyncImage
                  className="imge-training"
                  src={
                    eventInfo.event.extendedProps.image.url ||
                    getDefaultImage(imageType.training)
                  }
                />
              </div>
            </div>
            <div className="training-info">
            <Row  className="training-row">
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    <Col className="icon">
                      <FontAwesomeIcon
                        icon={iconType1}
                        style={color1}
                        
                      /></Col>
                    <Col className="training-content">

                        <span className="heading" style={color1}>
                          {t("course")}:
                        </span>{" "}
                        <span className="info" style={color1}>
                          {eventInfo.event.title}
                        </span>

                    </Col>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    {/* <Col>
                      <FontAwesomeIcon
                        icon={faLocationDot}
                        style={color1}
                        className="icon"
                      />
                    </Col> */}
                    {/* <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          Area:
                        </span>{" "}
                        <span className="info" style={color1}>
                          {eventInfo.event.extendedProps.location?.city}
                        </span>
                      </div>
                    </Col> */}
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    <Col>
                      <FontAwesomeIcon
                        icon={faClock}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          {t("time")}:
                        </span>{" "}
                        <span className="info info-time" style={color1}>
                          {("at")} {moment(eventInfo.event.start).format("h:mm a")}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  {/* <Row className="content-row">
                    <Col>
                      <FontAwesomeIcon
                        icon={faTag}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          Price:
                        </span>{" "}
                        <span className="info" style={color1}>
                          Kr.{" "}
                          {`${eventInfo.event.extendedProps.coursePrice.toFixed(2)}`}
                        </span>
                      </div>
                    </Col>
                  </Row> */}
                </Col>
              </Row>
              {/* <Row className='attende-content '>
                                          <Col className={duration >= 3600000 ? 'training-content' : 'training-content-half-hr'}>
                                              <span className='heading'>Attendees</span>{eventInfo.event.extendedProps.attendees.map((attendee: any, index: number) => (
                                                  <span className='info attende-name' key={index}>{attendee.name}</span>
                                              ))}
                                          </Col>
                                      </Row> */}
            </div>
            <div className="book-btn">
              {/* {isTrainer || isSchool ? ( */}
              
              <EqButton
                  onClick={() =>{
                    handleCourseActionClick(eventInfo.event.id)
                    // navigate(`/student/trainingCourse?id=${eventInfo.event.id}`);
                  }
                  }
                >
                  {t("view")}
                </EqButton>
            </div>
          </div>
        );
        // month
      } else if (view.type === "dayGridMonth") {
        if(isMobile){
          return (
            <div className="fc-event-mobile-month" style={{ backgroundColor: event.extendedProps.eventColor }}></div>
          );
        }else{
          return (
            <>
              <div
                className="fc-event-month events-month"
                style={style1}
              >
                <div className="month-title">{eventInfo.event.title}</div>
                <div>{eventInfo.event.extendedProps.type}</div>
              </div>
              <div className="hide">{eventInfo.event.extendedProps.type}</div>
            </>
          );
        }
       
      } else {
        // week
        if(isMobile){
          return (
            <div className="fc-event-mobile-week" style={style1}>
              <span className="fc-event-title">{event.title}</span>
            </div>
          );
        }
        else{
          return (
            <div className="my-event timeGridWeek-event" style={style1}>
              <FontAwesomeIcon icon={iconType1} style={color1} className="icon" />
              {/* <AsyncImage
                          className= 'icon'
  
                              alt="" src={iconType} /> */}
              <Col className="timeGridWeek-info training-info">
                <Row
                  className="timeGridWeek-title training-content"
                  style={color1}
                >
                  {eventInfo.event.title}
                </Row>
                <Row
                  className="timeGridWeek-time training-content"
                  style={color1}
                >
                  {moment(eventInfo.event.start).format("h:mm a")}
                </Row>
              </Col>
            </div>
          );
        }
        
      }
      // Product
    }
    else if (eventInfo.event.extendedProps.type === "horseTraining") {
      if (view.type === "timeGridDay") {
        // Render the event content for the month view
        return (
          <div className="my-event timeGridDay-event" style={style1}>
            <div className="img-container">
        
              <div className="image-size">
                <AsyncImage
                  className="imge-training"
                  src={
                    eventInfo.event.extendedProps.imageUrl ||
                    getDefaultImage(imageType.training)
                  }
                />
              </div>
            </div>
            <div className="training-info">
            <Row  className="training-row">
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    <Col className="icon">
                      <FontAwesomeIcon
                        icon={iconType1}
                        style={color1}
                        
                      /></Col>
                    <Col className="training-content">

                        <span className="heading" style={color1}>
                          {t("horseTraining")}:
                        </span>{" "}
                        <span className="info" style={color1}>
                          {eventInfo.event.title}
                        </span>

                    </Col>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    <Col>
                      <FontAwesomeIcon
                        icon={faTag}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          {("type")}:
                        </span>{" "}
                        <span className="info" style={color1}>
                          {EqHorseTrainingType[eventInfo.event.extendedProps.trainingType]}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    <Col>
                      <FontAwesomeIcon
                        icon={faClock}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          {t("time")}:
                        </span>{" "}
                        <span className="info info-time" style={color1}>
                          {t("at")} {moment(eventInfo.event.start).format("h:mm a")}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  {/* <Row className="content-row">
                    <Col>
                      <FontAwesomeIcon
                        icon={faTag}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          Price:
                        </span>{" "}
                        <span className="info" style={color1}>
                          Kr.{" "}
                          {`${eventInfo.event.extendedProps.coursePrice.toFixed(2)}`}
                        </span>
                      </div>
                    </Col>
                  </Row> */}
                </Col>
              </Row>
              {/* <Row className='attende-content '>
                                          <Col className={duration >= 3600000 ? 'training-content' : 'training-content-half-hr'}>
                                              <span className='heading'>Attendees</span>{eventInfo.event.extendedProps.attendees.map((attendee: any, index: number) => (
                                                  <span className='info attende-name' key={index}>{attendee.name}</span>
                                              ))}
                                          </Col>
                                      </Row> */}
            </div>
            <div className="book-btn">
              
            <EqButton
                  onClick={() =>{

                    
                    navigate(`/trainer/taskList?id=${eventInfo.event.id}`);
                  }
                  }
                >
                  {t("view")}
                </EqButton>
            </div>
          </div>
        );
        // month
      } else if (view.type === "dayGridMonth") {
        if(isMobile){
          return (
            <div className="fc-event-mobile-month" style={{ backgroundColor: event.extendedProps.eventColor }}></div>
          );
        }else{
          return (
            <>
              <div
                className="fc-event-month events-month"
                style={style1}
              >
                <div className="month-title">{eventInfo.event.title}</div>
                <div>{eventInfo.event.extendedProps.type}</div>
              </div>
              <div className="hide">{eventInfo.event.extendedProps.type}</div>
            </>
          );
        }
      
      } else {
        // week
        if(isMobile){
          return (
            <div className="fc-event-mobile-week" style={style1}>
              <Row className="fc-event-title">{event.title}</Row>
              <Row className="">{EqHorseTrainingType[eventInfo.event.extendedProps.trainingType]}
              </Row>
            </div>
          );
        }else{
          return (
            <div className="my-event timeGridWeek-event" style={style1}>
              <FontAwesomeIcon icon={iconType1} style={color1} className="icon" />
              {/* <AsyncImage
                          className= 'icon'
  
                              alt="" src={iconType} /> */}
              <Col className="timeGridWeek-info training-info">
                <Row
                  className="timeGridWeek-title training-content"
                  style={color1}
                >
                  {eventInfo.event.title}
                </Row>
                <Row
                  className="timeGridWeek-time training-content"
                  style={color1}
                >
                                         {EqHorseTrainingType[eventInfo.event.extendedProps.trainingType]}

                </Row>
                <Row
                  className="timeGridWeek-time training-content"
                  style={color1}
                >
                  {moment(eventInfo.event.start).format("h:mm a")}
                </Row>
              </Col>
            </div>
          );
        }
       
      }
      
    }
    else if (eventInfo.event.extendedProps.type === "horseTask") {
      if (view.type === "timeGridDay") {
        // Render the event content for the month view
        return (
          <div className="my-event timeGridDay-event" style={style1}>
            <div className="img-container">
        
              <div className="image-size">
                <AsyncImage
                  className="imge-training"
                  src={
                    eventInfo.event.extendedProps.imageUrl ||
                    getDefaultImage(imageType.training)
                  }
                />
              </div>
            </div>
            <div className="training-info">
            <Row  className="training-row">
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    <Col className="icon">
                      <FontAwesomeIcon
                        icon={iconType1}
                        style={color1}
                        
                      /></Col>
                    <Col className="training-content">

                        <span className="heading" style={color1}>
                         {t("horseTask")}:
                        </span>{" "}
                        <span className="info" style={color1}>
                          {eventInfo.event.title}
                        </span>

                    </Col>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                  <Row className="content-row">
                    <Col>
                      <FontAwesomeIcon
                        icon={faTag}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          {("type")}:
                        </span>{" "}
                        <span className="info" style={color1}>
                          {EqTaskTypes[eventInfo.event.extendedProps.taskType]}
                        </span>
                      </div>
                    </Col>
                  </Row>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    <Col>
                      <FontAwesomeIcon
                        icon={faClock}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          {t("time")}:
                        </span>{" "}
                        <span className="info info-time" style={color1}>
                          {t("at")} {moment(eventInfo.event.start).format("h:mm a")}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col className="training-col" sm={6} md={12}>
                  <Row className="content-row">
                    {/* <Col>
                      <FontAwesomeIcon
                        icon={faTag}
                        style={color1}
                        className="icon"
                      />
                    </Col>
                    <Col>
                      <div className="training-content">
                        <span className="heading" style={color1}>
                          Price:
                        </span>{" "}
                        <span className="info" style={color1}>
                          Kr.{" "}
                          {`${eventInfo.event.extendedProps.coursePrice.toFixed(2)}`}
                        </span>
                      </div>
                    </Col> */}
                  </Row>
                </Col>
              </Row>
              {/* <Row className='attende-content '>
                                          <Col className={duration >= 3600000 ? 'training-content' : 'training-content-half-hr'}>
                                              <span className='heading'>Attendees</span>{eventInfo.event.extendedProps.attendees.map((attendee: any, index: number) => (
                                                  <span className='info attende-name' key={index}>{attendee.name}</span>
                                              ))}
                                          </Col>
                                      </Row> */}
            </div>
            <div className="book-btn">
              
                 <EqButton
                  onClick={() =>{

                    
                    navigate(`/trainer/taskList?id=${eventInfo.event.id}`);
                  }
                  }
                >
                  {t("view")}
                </EqButton>
            </div>
          </div>
        );
        // month
      } else if (view.type === "dayGridMonth") {
        if(isMobile){
          return (
            <div className="fc-event-mobile-month" style={{ backgroundColor: event.extendedProps.eventColor }}></div>
          );
        }else{
          return (
            <>
              <div
                className="fc-event-month events-month"
                style={style1}
              >
                <div className="month-title">{eventInfo.event.title}</div>
                <div>{eventInfo.event.extendedProps.type}</div>
              </div>
              <div className="hide">{eventInfo.event.extendedProps.type}</div>
            </>
          );
        }
        
      } else {
        // week
        if(isMobile){
          return (
            <div className="fc-event-mobile-week" style={style1}>
              <Row className="fc-event-title">{event.title}</Row>
              <Row className="">{EqTaskTypes[eventInfo.event.extendedProps.taskType]}
              </Row>
            </div>
          );
        }else{
          return (
            <div className="my-event timeGridWeek-event" style={style1}>
              <FontAwesomeIcon icon={iconType1} style={color1} className="icon" />
              {/* <AsyncImage
                          className= 'icon'
  
                              alt="" src={iconType} /> */}
              <Col className="timeGridWeek-info training-info">
                <Row
                  className="timeGridWeek-title training-content"
                  style={color1}
                >
                  {eventInfo.event.title}
                </Row>
                <Row
                  className="timeGridWeek-time training-content"
                  style={color1}
                >
                {EqTaskTypes[eventInfo.event.extendedProps.taskType]}

                </Row>
                <Row
                  className="timeGridWeek-time training-content"
                  style={color1}
                >
                  {moment(eventInfo.event.start).format("h:mm a")}
                </Row>
              </Col>
            </div>
          );
        }
       
      }
     
    }
    
  };





  const handleItemClick = (eventClickInfo: any) => {
    // handle item clicked

    const clickedEventDate = eventClickInfo.event.start as Date;
    // eventClickInfo.view.calendar.changeView('timeGridDay', clickedEventDate);

    const timeInString = `${clickedEventDate
      .getHours()
      .toString()
      .padStart(2, "0")}:${clickedEventDate
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;

    const calendarApi = calendarRef?.current?.getApi();
    // Switch to the day view
    if (calendarApi) {
      // Switch to the day view and set the view to the clicked event's time
      calendarApi.changeView("timeGridDay", clickedEventDate);

      // calendarApi.gotoDate(clickedEventDate);

      calendarApi.scrollToTime(timeInString);

      // calendarApi.scrollToTime(clickedEventDate.getHours(), clickedEventDate.getMinutes());
    }
    // alert(arg.dateStr);
    // console.log(arg.date);
  };


  const handleDayClick = (date: Date) => {
    console.log("Clicked date:", date);
    // Perform  actions or navigate to a specific day view
  };







    const MyCalendarData = (events: IEqPublicEvent[] | undefined, trainings: IGetSchoolTrainingDto[] | GetTrainingInfoDto[] | undefined, courses: CourseUI[] | null | undefined, horsesList: EqEntityHorse[] | undefined, selectedFilter:string) => {
        let calendarTrainings = [];
        if (trainings && (selectedFilter === "All" || selectedFilter === "Training")) {
            calendarTrainings = trainings.flatMap((training:any) => {
                const { id, startTime, endTime, trainingTimes, ...rest } = training;
                
                return trainingTimes.map((trainingTime:any, idTrain:any) => ({
                    ...rest,
                    type: "training",
                    title: training.title,
                    trainingTitle: training.title,
                    start: new Date(trainingTime.startTime),
                    end: new Date(trainingTime.endTime),
                    eventColor: ColorMapping.Training,
                    count: trainingTimes.length,
                    monthView: idTrain > 0 ? false : true,
                    trainingTimes:trainingTimes,

                }));
            });
        }

        const calendarEvents:any = [];
        if (events && (selectedFilter === "All" || selectedFilter === "Events")) {
            events.forEach((pEvt:any) => {
                const { startDate, endDate, ...evt } = pEvt;
                calendarEvents.push({
                    ...evt,
                    id: pEvt.id,
                    type: "event",
                    title: pEvt.title,
                    start: new Date(pEvt.startDate),
                    end: new Date(pEvt.startDate + 1 * 60 * 60 * 1000),
                    eventColor: ColorMapping.Events,
                });
            });
        }

        const coursesList:any = [];
        if (courses && (selectedFilter === "All" || selectedFilter === "Courses")) {
            courses.forEach((course:any) => {
                const { startDate, endDate, ...evt } = course;
                coursesList.push({
                    ...evt,
                    id: course.id,
                    type: "course",
                    title: course.title,
                    start: new Date(course.startDate),
                    end: new Date(course.startDate + 1 * 60 * 60 * 1000),
                    eventColor: ColorMapping.Courses,
                });
            });
        }
        
        let horseTasksData:any = [];
        if (horsesList && (selectedFilter === "All" || selectedFilter === "Horse")) {
            horsesList.forEach((horse:any) => {
                horse.horseTasks.forEach((task:any) => {
                    horseTasksData.push({
                        ...task,
                        type: "horseTask",
                        title: `${horse.name}`,
                        description: task.description,
                        start: new Date(task.date),
                        end: new Date(task.date + 1 * 60 * 60 * 1000),
                        eventColor: ColorMapping.Horse,
                    });
                });
            });
        }

        let horseTrainingsData:any = [];
        if (horsesList && (selectedFilter === "All" || selectedFilter === "Horse")) {
            horsesList.forEach((horse:any) => {
                horse.horseTrainings.forEach((training:any) => {
                    horseTrainingsData.push({
                        ...training,
                        type: "horseTraining",
                        title: `${horse.name}`,
                        imageUrl: horse.imageUrl,
                        start: new Date(training.date),
                        end: new Date(training.date + training.durationInMinutes * 60 * 1000),
                        eventColor: ColorMapping.Horse,
                    });
                });
            });
        }

        switch (selectedFilter) {
            case "Horse":
                return [...horseTasksData, ...horseTrainingsData];
            case "Events":
                return calendarEvents;
            case "Training":
                return calendarTrainings;
            case "Courses":
                return coursesList;
            case "All":
            default:
                return [
                    ...calendarTrainings,
                    ...calendarEvents,
                    ...coursesList,
                    ...horseTasksData,
                    ...horseTrainingsData,
                ];
        }
    };

    // Function to handle filter change
    const handleFilterChange = (value:any) => {
        setSelectedFilter(value);
    };

    // Recalculate calendarData whenever selectedFilter or props change
    React.useEffect(() => {
        const filteredData = MyCalendarData(events, trainings, courses, horsesList, selectedFilter);
        setCalendarData(filteredData);
    }, [events, trainings, courses, horsesList, selectedFilter]);

    const ColorMapping = {
        Horse: "#013220",
        Courses: "#AA336A",
        Events: "#259FAA",
        Training: "#1976D2",
    }
  
    const filterOptions = useMemo(() => {
      const options = [
        {
          value: "All",
          label: (
            <span>
              <span
                style={{
                  display: "inline-block",
                  width: "12px",
                  height: "12px",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "2px",
                  marginRight: "8px",
                }}
              ></span>
              {t("all")}
            </span>
          ),
        },
      ];
  
      if (horsesList && horsesList.length > 0) {
        options.push({
          value: "Horse",
          label: (
            <span>
              <span
                style={{
                  display: "inline-block",
                  width: "12px",
                  height: "12px",
                  backgroundColor: ColorMapping.Horse,
                  borderRadius: "2px",
                  marginRight: "8px",
                }}
              ></span>
              {t("horse")}
            </span>
          ),
        });
      }
  
      if (events && events.length > 0) {
        options.push({
          value: "Events",
          label: (
            <span>
              <span
                style={{
                  display: "inline-block",
                  width: "12px",
                  height: "12px",
                  backgroundColor: ColorMapping.Events,
                  borderRadius: "2px",
                  marginRight: "8px",
                }}
              ></span>
              {t("events")}
            </span>
          ),
        });
      }
  
      if (trainings && trainings.length > 0) {
        options.push({
          value: "Training",
          label: (
            <span>
              <span
                style={{
                  display: "inline-block",
                  width: "12px",
                  height: "12px",
                  backgroundColor: ColorMapping.Training,
                  borderRadius: "2px",
                  marginRight: "8px",
                }}
              ></span>
              {t("training")}
            </span>
          ),
        });
      }
  
      if (courses && courses.length > 0) {
        options.push({
          value: "Courses",
          label: (
            <span>
              <span
                style={{
                  display: "inline-block",
                  width: "12px",
                  height: "12px",
                  backgroundColor: ColorMapping.Courses,
                  borderRadius: "2px",
                  marginRight: "8px",
                }}
              ></span>
              {t("courses")}
            </span>
          ),
        });
      }
  
      return options;
    }, [events, trainings, courses, horsesList]);
  return (
      <div className="eq-dash-calendar-container">

      {/* <div className={`eq-calendar ${classNames ? classNames : ""}`} >
                <Calendar fullscreen={false} dateCellRender={dateCellRender} monthCellRender={monthCellRender}
                    onSelect={selectFun}
                />
                </div> */}
        
           

          <div className="filter-dropdown">
              <Select
                  defaultValue={selectedFilter}
                  style={{ width: 200, borderRadius: 20}}
                  onChange={handleFilterChange}
                  options={filterOptions}
                  className="select-dropdown"
                  dropdownStyle={{ borderRadius: 10 }}
              />
          </div>

        

      <FullCalendar
      // dayMaxEventRows={2} // Show max 2 events per day
// height={"80vh"}
           buttonText={{
            today: t("today"),
            month: t("month"),
            week: t("week"),
            day: t("day"),
          }}
          locale={i18n.language || "en"}
        ref={calendarRef}
        plugins={plugins}
        allDaySlot={false}
        initialView={view}
        viewDidMount={handleViewChange}
        viewWillUnmount={handleViewChange}
        headerToolbar={{
          left: "today",
          center: "prev title next",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        navLinks={true}
        nowIndicator={true}
        eventClick={handleItemClick}
        // events={myEvents}
        events={calendarData}
        eventContent={renderEventContent}
        // dayCellContent={renderDayCellContent}
        editable={true}
        dragScroll={true}
         slotMinTime="08:00:00"
        //  slotMaxTime="20:00:00"  // Optional: End at 8 PM
        scrollTime="06:00:00"
        scrollTimeReset={false}
        droppable={true}
        // eventDrop={handleEventDrop}
        // eventResize={handleEventResize}
        slotEventOverlap={false}
        // select={handleDateSelect}
        eventAdd={handleEventAdd}
        views={{
          dayGridMonth: {
            titleFormat: { year: "numeric", month: "long" },
          },
          timeGridWeek: {
            titleFormat: { year: "numeric", month: "short", day: "numeric" },
            dayHeaderFormat: {
              weekday: "short",
              day: "numeric",
            },
            viewClassNames: ["my-timegridweek"],
          },
          timeGridDay: {
            titleFormat: { year: "numeric", month: "short", day: "numeric" },
          },
          listWeek: {
            titleFormat: { year: "numeric", month: "long", day: "numeric" },
          },
        }}

       
      />

     
    </div>
  );
};
export default EqDashboardCalendar;
